<template>
	<div class="p-0 m-0" :class="hidePageNumber ? 'd-flex align-items-center justify-content-between' : ''">
		<div class="counter" style="margin-right: 10px;">
			<span v-if="showDropdownPerPage" style="color: #848484;" class="d-flex align-items-center">
				<span>Showing</span>
				<CSelect style="min-width: 60px; max-width: fit-content !important;" @input="updatePerPage"
					v-model="perPageValue" :options="perPageOptions" :itemValue="'value'" :itemText="'text'" class="py-0 mx-2">
				</CSelect>
				<span>
					{{ perPageValue >= totalItems ? totalItems : showingItem.start }} - {{ perPageValue >= totalItems ? totalItems
						:
						showingItem.end }} of {{ totalItems }} {{ title }}
				</span>
			</span>
			<span v-else style="color: #848484;">
				Showing {{ perPageValue >= totalItems ? totalItems : showingItem.start }} - {{ perPageValue >= totalItems ?
					totalItems : showingItem.end }} of {{ totalItems }} {{ title }}
			</span>
		</div>

		<nav v-if="perPage < totalItems && !hidePageNumber" aria-label="Page navigation example">
			<ul class="pagination m-0 p-0 my-2">
				<li class="page-item" @click="setActivePage(0, 'navigation_first')" v-if="isActive != 1">
					<div class="page-link">
						<v-icon size="small" color="primary">mdi-chevron-double-left</v-icon>
						First
					</div>
				</li>
				<li class="page-item" @click="setActivePage(0, 'navigation_prev')" v-if="isActive != 1">
					<div class="page-link">
						<v-icon size="small" color="primary">mdi-chevron-left</v-icon>
						Prev
					</div>
				</li>
				<li v-for="page in pages" class="page-item" :class="isActive == page ? 'active' : ''">
					<a class="page-link" href="javascript:void(0)" @click="setActivePage(page)">{{ page }}</a>
				</li>
				<li class="page-item" @click="setActivePage(0, 'navigation_next')"
					v-if="isActive != totalPages && totalItems >= 1">
					<div class="page-link">
						Next
						<v-icon size="small" color="primary">mdi-chevron-right</v-icon>
					</div>
				</li>
				<li class="page-item" @click="setActivePage(0, 'navigation_last')"
					v-if="isActive != totalPages && totalItems >= 1">
					<div class="page-link">
						Last
						<v-icon size="small" color="primary">mdi-chevron-double-right</v-icon>
					</div>
				</li>
			</ul>
		</nav>
		<nav v-else-if="hidePageNumber" class="Page navigation example">
			<ul class="pagination m-0 p-0 my-2">
				<li class="" @click="setActivePage(0, 'navigation_prev')">
					<button :disabled="isActive == 1" role="button" class="btn btn-sm btn-outline-primary"
						:style="`border-color: ${primaryColor}; color: ${primaryColor}`">
						<v-icon size="small" color="primary">mdi-chevron-left</v-icon>
					</button>
				</li>
				<li class="ml-3" @click="setActivePage(0, 'navigation_next')">
					<button :disabled="!(isActive != totalPages && totalItems >= 1)" role="button"
						class="btn btn-sm btn-outline-primary" :style="`border-color: ${primaryColor}; color: ${primaryColor}`">
						<v-icon size="small" color="primary">mdi-chevron-right</v-icon>
					</button>
				</li>
			</ul>
		</nav>
	</div>
</template>

<script>
import CSelect from './c-select.vue'
export default {
  components: {
    CSelect
  },
  props: {
    isAllParamNull: {
      default: false,
      type: Boolean
    },
    hidePageNumber: {
      default: false,
      type: Boolean
    },
    additionalParams: {
      default: "",
      type: String,
    },
    totalItems: {
      default: 0,
      type: Number,
    },
    perPage: {
      default: 15,
      type: Number,
    },
    currentPage: {
      default: null,
      type: Number,
    },
    title: {
      default: '',
      type: String
    },
    showDropdownPerPage: {
      default: false,
      type: Boolean
    },
    perPageOptionsData: {
      type: Array,
      default: null
    },
    watchData: [String, Number, Boolean]
  },
  data() {
    return {
      initLoad: true,
      isActive: 1,
      showingItem: {
        start: 0,
        end: 0
      },
      perPageValue: 15, 
    }
  },
  computed: {
    perPageOptions() {
      if (this.perPageOptionsData?.length) {
        return this.perPageOptionsData.map((option) => ({
          text: `${option}`,
          value: option
        }))
      }

      return [
        { text: '15', value: 15 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
      ]
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.perPageValue) 
    },
    primaryColor() {
      return this.$store.state.orgPrimaryColor
    },
    pages() {
      const numVisiblePages = 5;
      const halfStart = Math.floor(numVisiblePages / 2);

      if (this.totalPages <= numVisiblePages) {
        return Array.from({ length: this.totalPages }, (_, i) => i + 1);
      }

      let startIndex = Math.max(this.isActive - halfStart, 1);
      let endIndex = Math.min(startIndex + numVisiblePages - 1, this.totalPages);

      if (endIndex < numVisiblePages) {
        startIndex = 1;
        endIndex = Math.min(numVisiblePages, this.totalPages);
      }

      if (startIndex === 1) {
        endIndex = numVisiblePages;
      }

      if (endIndex === this.totalPages) {
        startIndex = endIndex - numVisiblePages + 1;
      }

      const pagesArray = startIndex > 1 ? ['...'] : [];
      pagesArray.push(...Array.from({ length: endIndex - startIndex + 1 }, (_, i) => startIndex + i));
      if (endIndex < this.totalPages) {
        pagesArray.push('...');
      }

      return pagesArray;
    },
  },
  created() {
    const queryParams = this.$route.query;
    const pageValue = queryParams.page;

    this.isActive = !this.hidePageNumber && pageValue ? Number(pageValue) : 1
    this.perPageValue = this.perPage ?? 15 // default value
    this.updateShowingItem()
  },
  mounted() {
    setTimeout(() => {
      this.initLoad = false
    }, 1500)
  },
  watch: {
    'watchData': function (newVal, oldVal) {
      if (oldVal != newVal) {
        this.setActivePage(1, 'direct')
      }
    },
    '$route.query.page': {
      handler(newVal) {
        const page = Number(newVal) || 1
        this.isActive = page
        this.updateShowingItem()
      },
      immediate: true
    },
    totalItems() {
      this.updateShowingItem()
    },
    currentPage(newVal) {
      const page = Number(newVal) || 1

      if (page !== this.isActive) {
        this.isActive = page
        this.updateShowingItem()
      }
    }
  },
  methods: {
    setActivePage(number, type = "direct") {
      if (number === '...') return;

      const filteredPages = this.pages.filter(page => page !== '...');

      const lastPageIndex = filteredPages.length - 1;
      const lastPage = filteredPages[lastPageIndex];

      if (type === 'direct') this.isActive = number;
      else if (type === 'navigation_next' && this.isActive < lastPage) this.isActive++;
      else if (type === 'navigation_prev' && this.isActive > 1) this.isActive--;
      else if (type === 'navigation_first') this.isActive = 1;
      else if (type === 'navigation_last') this.isActive = this.totalPages;

      this.updateShowingItem()
      this.$emit('currentPage', this.isActive)
      this.applyParams(this.isActive)
    },
   updatePerPage() {
		if (!this.initLoad) {
			if (this.$route.query.perPage != this.perPageValue) {
			const newTotalPages = Math.ceil(this.totalItems / this.perPageValue)
			let page = this.isActive > newTotalPages ? 1 : this.isActive

			this.$router.push({ 
				query: { page: page, perPage: this.perPageValue, section: this.additionalParams } 
			});

			this.isActive = page
			this.updateShowingItem()

			this.$emit('currentPage', page)
			setTimeout(() => {
				this.$emit('loadPerPage', this.perPageValue)
			}, 800)
			}
		}
	},
    updateShowingItem() {
      const start = (this.isActive - 1) * this.perPageValue + 1; 
      const end = Math.min(start + this.perPageValue - 1, this.totalItems); 
      if (this.showingItem.start !== start || this.showingItem.end !== end) {
        this.showingItem = { start, end };
      }
    },
    applyParams(page) {
      if (!this.initLoad) {
        this.$router.push({ query: { page: page, perPage: this.perPageValue, section: this.additionalParams } });
        this.$emit('currentPage', page)
        this.$emit('loadData', this.isActive)
        this.updateShowingItem()
      }
    }
  },
}
</script>
